import React, { useMemo, useState, useRef, useLayoutEffect } from "react";
import {
    Grid,
    Paper,
    Typography,
    Box,
    Table,
    TableHead,
    TableRow,
    TableCell,
    TableBody,
    // TablePagination,
    TextField,
    TableContainer
} from "@mui/material";
import Select, { components } from "react-select";
import { DateRange } from "react-date-range";
import { ClickAwayListener } from "@mui/material";
import Loader from "utils/Loader";
import IconButton from "@mui/material/IconButton";
import CloseIcon from "@mui/icons-material/Close";
import { Clear } from '../../../node_modules/@mui/icons-material/index';


import CollectionReceivedController from "pages/Controller/CollectionReceivedController";
import CollectionReceivedLineChart from "./Charts/CollectionReceivedLineChart";
import CollectionReceivedBarChart from "./Charts/CollectionReceivedBarChart";
import ZoomWrapper from 'utils/ZoomWrapper';
import "react-date-range/dist/styles.css";
import "react-date-range/dist/theme/default.css";

const addSelectAllOption = (options) => [
    { label: "Select All", value: "__ALL__", isSelectAll: true },
    ...options
];

/* ================= CHECKBOX OPTION (REUSABLE) ================= */
const CheckboxOption = (props) => {
    const { label, amount, isSelectAll } = props.data;
    const { isSelected, selectOption, getValue } = props;

    // 🔥 FORCE Select-All checked state
    const allSelected =
        isSelectAll &&
        getValue().length > 0 &&
        getValue().length === props.options.filter(o => !o.isSelectAll).length;

    const checked = isSelectAll ? allSelected : isSelected;

    const handleClick = (e) => {
        e.preventDefault();
        e.stopPropagation();
        selectOption(props.data);
    };

    return (
        <button
            type="button"
            onMouseDown={handleClick}
            style={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                padding: "6px 10px",
                cursor: "pointer",
                background: isSelectAll ? "#f5f5f5" : "#fff",
                color: "#000",
                border: "none",
                width: "100%",
                textAlign: "left",
                fontSize: "13px"
            }}
        >
            <div style={{ display: "flex", gap: 8, alignItems: "center" }}>
                <input
                    type="checkbox"
                    checked={checked}
                    readOnly
                    style={{ width: 14, height: 14 }}
                />
                <span style={{ color: "#000", fontWeight: 400 }}>{label}</span>
            </div>

            {/* {amount && (
                <span style={{ fontSize: "12px", color: "#b1005a", fontWeight: 600 }}>
                    {amount}
                </span>
            )} */}
        </button>
    );
};

const CollectionReceived = () => {
    const {
        // tableData,
        summaryChart,
        barChartData,
        cloading,
        // page,
        // totalRecords,
        // handleChangePage,

        zoneOptions,
        customerNameOptions,
        monthOptions,


        filters,
        handleFilterChange,
        handleDateFromChange,
        handleDateToChange,
        months,
        tableRows,
        grandTotal,
        todaysDate,
        prevAndCurrentFY,
        getFYMonthFlowHeader,
        getSelectedFYLabel,
        handleCustomerSearch,
        loadAllCustomers,
        fyLabel,
        zoneTotals,
        monthlySalesData,
        isFromApp
    } = CollectionReceivedController();

    const [showCalendar, setShowCalendar] = useState(false);

    const clearDateRange = () => {
        setRange([
            {
                startDate: null,
                endDate: null,
                key: "selection",
            },
        ]);

        handleDateFromChange("");
        handleDateToChange("");
    };

    const [range, setRange] = useState([
        {
            startDate: filters.fromDate ? new Date(filters.fromDate) : null,
            endDate: filters.toDate ? new Date(filters.toDate) : null,
            key: "selection"
        }
    ]);

    const handleClearDate = () => {
        setRange([
            {
                startDate: null,
                endDate: null,
                key: "selection"
            }
        ]);

        handleDateFromChange("");
        handleDateToChange("");
    };


    const NoMultiValue = () => null;
    const formatToLakh = (value) => {
        const num = Number(value || 0);
        const lakhValue = (num / 100000).toLocaleString("en-IN", {
            minimumFractionDigits: 2,
            maximumFractionDigits: 2
        });
        return `${lakhValue} L`;
    };

    const formatSalesToLakh = (value) => {
        const num = Math.round(Number(value || 0) * 100) / 100;
        return `${num.toLocaleString("en-IN", {
            minimumFractionDigits: 2,
            maximumFractionDigits: 2
        })} L`;
    };


    const singleLineSelectStyles = {
        menuPortal: (b) => ({ ...b, zIndex: 9999 }),
        control: (base) => ({
            ...base,
            minHeight: 38,
            height: 38
        }),
        valueContainer: (base) => ({
            ...base,
            height: 38,
            padding: "0 8px",
            overflow: "hidden"
        }),
        placeholder: (base) => ({
            ...base,
            whiteSpace: "nowrap",
            overflow: "hidden",
            textOverflow: "ellipsis",
            maxWidth: "100%",
            color: "#000",
            fontWeight: 500
        }),
        indicatorsContainer: (base) => ({
            ...base,
            height: 38
        })
    };

    const [zoneSearchText, setZoneSearchText] = useState("");
    const [customerSearchText, setCustomerSearchText] = useState("");

    const makeClearTextOnlyIndicator = (setText) =>
        function ClearTextOnlyIndicator(props) {
            return (
                <components.ClearIndicator
                    {...props}
                    innerProps={{
                        ...props.innerProps,
                        onMouseDown: (e) => {
                            e.preventDefault();
                            e.stopPropagation();
                            setText("");        // ✅ clear only typed text
                        }
                    }}
                />
            );
        };

    const ZoneClearIndicator = makeClearTextOnlyIndicator(setZoneSearchText);
    const CustomerClearIndicator = makeClearTextOnlyIndicator(setCustomerSearchText);

    ///customer dropdown
    const [isCustomerMenuOpen, setIsCustomerMenuOpen] = useState(false);

    // EXCLUDED CUSTOMERS
    const excludedCustomers = customerNameOptions.filter(
        (c) => !filters.customerName.some((s) => s.value === c.value)
    );

    const selectedCustomerCount = filters.customerName.length;

    const customerExcludedCount = excludedCustomers.length;
    const customerExcludedNames = excludedCustomers.map((c) => c.label);
    const customerExcludedText = customerExcludedNames.join(", ");

    const customerPlaceholder = isCustomerMenuOpen
        // ? `CUSTOMER NAME${customerExcludedCount
        //     ? ` excluded count (${customerExcludedCount})`
        //     : ""
        // }`
        ? `CUSTOMER NAME${selectedCustomerCount ? ` selected (${selectedCustomerCount})` : ""}`
        : customerExcludedCount
            ? `CUSTOMER NAME: Excluded: ${customerExcludedText.length > 45
                ? customerExcludedText.slice(0, 45) + "..."
                : customerExcludedText
            }`
            : "CUSTOMER NAME";

    const customerTooltip =
        customerExcludedCount > 0
            ? `Excluded:\n${customerExcludedNames.join("\n")}`
            : "";

    const handleCustomerChange = (selected) => {
        if (!selected) {
            handleFilterChange("customerName")([]);
            return;
        }

        // If Select All clicked
        if (selected.some(o => o.value === "__ALL__")) {
            const allSelected =
                filters.customerName.length === customerNameOptions.length;

            handleFilterChange("customerName")(
                allSelected ? [] : customerNameOptions
            );
            return;
        }

        handleFilterChange("customerName")(selected);
    };


    //zone dropdown
    const [isZoneMenuOpen, setIsZoneMenuOpen] = useState(false);

    // EXCLUDED ZONES
    const excludedZones = zoneOptions.filter(
        (z) => !filters.zone.some((s) => s.value === z.value)
    );
    const selectedZoneCount = filters.zone.length;
    const zoneExcludedCount = excludedZones.length;
    const zoneExcludedNames = excludedZones.map((z) => z.label);
    const zoneExcludedText = zoneExcludedNames.join(", ");

    const zonePlaceholder = isZoneMenuOpen
        // ? `ZONE${zoneExcludedCount ? ` excluded count (${zoneExcludedCount})` : ""}`
        ? `ZONE${selectedZoneCount ? ` selected (${selectedZoneCount})` : ""}`
        : zoneExcludedCount
            ? `ZONE: Excluded: ${zoneExcludedText.length > 45
                ? zoneExcludedText.slice(0, 45) + "..."
                : zoneExcludedText
            }`
            : "ZONE";

    const zoneTooltip =
        zoneExcludedCount > 0
            ? `Excluded:\n${zoneExcludedNames.join("\n")}`
            : "";

    const handleZoneChange = (selected) => {
        if (!selected) {
            handleFilterChange("zone")([]);
            return;
        }

        // If Select All clicked
        if (selected.some(o => o.value === "__ALL__")) {
            const allSelected =
                filters.zone.length === zoneOptions.length;

            handleFilterChange("zone")(
                allSelected ? [] : zoneOptions
            );
            return;
        }

        handleFilterChange("zone")(selected);
    };

    /* ================= MONTH DROPDOWN ================= */

    const [isMonthMenuOpen, setIsMonthMenuOpen] = useState(false);

    const excludedMonths = monthOptions.filter(
        m => !filters.month.some(s => s.value === m.value)
    );

    const selectedMonthCount = filters.month.length;
    const monthExcludedCount = excludedMonths.length;
    const monthExcludedText = excludedMonths.map(m => m.label).join(", ");

    const monthPlaceholder = isMonthMenuOpen
        ? `MONTH${selectedMonthCount ? ` selected (${selectedMonthCount})` : ""}`
        : monthExcludedCount
            ? `MONTH: Excluded: ${monthExcludedText.length > 45
                ? monthExcludedText.slice(0, 45) + "..."
                : monthExcludedText
            }`
            : "MONTH";

    const handleMonthChange = (selected) => {
        if (!selected) {
            handleFilterChange("month")([]);
            return;
        }

        if (selected.some(o => o.value === "__ALL__")) {
            const allSelected = filters.month.length === monthOptions.length;
            handleFilterChange("month")(allSelected ? [] : monthOptions);
            return;
        }

        handleFilterChange("month")(selected);
    };

    const salesTableData = useMemo(() => {
        const zones = Array.isArray(monthlySalesData?.zones) ? monthlySalesData.zones : [];
        const grandTotalRaw = Array.isArray(monthlySalesData?.grandTotal) ? monthlySalesData.grandTotal : [];

        const zoneTable = zones.map((zoneEntry) => {
            const zoneName = zoneEntry?.zone || zoneEntry?.name || zoneEntry?.region || "UNKNOWN";
            const customers = Array.isArray(zoneEntry?.customers) ? zoneEntry.customers : [];

            const rows = customers.map((customerEntry) => {
                const customerName = customerEntry?.customer || customerEntry?.customerName || customerEntry?.partyName || customerEntry?.name || "";
                const monthsMap = customerEntry?.months && typeof customerEntry.months === "object" ? customerEntry.months : {};
                const total = Number(customerEntry?.total || customerEntry?.amount || 0);

                return {
                    customer: customerName,
                    values: monthsMap,
                    total
                };
            });

            const monthTotals = {};
            months.forEach((month) => {
                monthTotals[month] = rows.reduce((sum, row) => sum + Number(row.values?.[month] || 0), 0);
            });

            return {
                zone: zoneName,
                rows,
                monthTotals,
                total: rows.reduce((sum, row) => sum + Number(row.total || 0), 0)
            };
        });

        const grandMonths = {};
        months.forEach((month) => {
            const calculatedTotal = zoneTable.reduce((sum, zone) => sum + Number(zone.monthTotals?.[month] || 0), 0);

            const apiGrandTotal = grandTotalRaw.find(
                (item) => String(item?.month || "").trim() === String(month).trim()
            );

            grandMonths[month] =
                apiGrandTotal?.amount !== undefined && apiGrandTotal?.amount !== null
                    ? Number(apiGrandTotal.amount)
                    : calculatedTotal;
        });
        // months.forEach((month) => {
        //     grandMonths[month] = zoneTable.reduce((sum, zone) => sum + Number(zone.monthTotals?.[month] || 0), 0);
        // });

        // months.forEach((month) => {
        //     const apiGrandTotal = grandTotalRaw.find(
        //         (item) => String(item?.month || "").trim() === String(month).trim()
        //     );

        //     grandMonths[month] = Number(apiGrandTotal?.amount || 0);
        // });

        const grandTotalValue = grandTotalRaw.reduce((sum, item) => {
            if (typeof item === "number") return sum + Number(item || 0);
            if (item && typeof item === "object") {
                return sum + Number(item.amount ?? item.value ?? item.total ?? 0);
            }
            return sum;
        }, 0);

        return {
            zones: zoneTable,
            grandMonths,
            grandTotalValue: grandTotalValue || zoneTable.reduce((sum, zone) => sum + Number(zone.total || 0), 0)
        };
    }, [monthlySalesData, months]);

    const salesByZoneCustomer = useMemo(() => {
        const map = {};
        salesTableData.zones.forEach((zoneEntry) => {
            const zoneName = zoneEntry?.zone || "UNKNOWN";
            const customerMap = {};
            (zoneEntry?.rows || []).forEach((row) => {
                customerMap[row?.customer || ""] = row;
            });
            map[zoneName] = customerMap;
        });
        return map;
    }, [salesTableData.zones]);

    const salesZoneMap = useMemo(() => {
        const map = {};
        salesTableData.zones.forEach((zoneEntry) => {
            map[zoneEntry?.zone || "UNKNOWN"] = zoneEntry;
        });
        return map;
    }, [salesTableData.zones]);

    // ================= ZONE ROW SPAN MAP =================
    const zoneRowSpanMap = {};

    tableRows.forEach((row) => {
        zoneRowSpanMap[row.zone] = (zoneRowSpanMap[row.zone] || 0) + 1;
    });

    // ================= STICKY TWO-ROW HEADER OFFSET =================
    // Row 2 (COLLECTION / SALES) must sit sticky directly beneath Row 1
    // (ZONE / CUSTOMER NAME / month / TOTAL). Instead of hard-coding a pixel
    // offset, measure Row 1's actual rendered height and reuse it.
    const combinedHeaderRow1Ref = useRef(null);
    const [combinedHeaderRow1Height, setCombinedHeaderRow1Height] = useState(0);

    useLayoutEffect(() => {
        const measureHeaderRow1 = () => {
            if (combinedHeaderRow1Ref.current) {
                setCombinedHeaderRow1Height(combinedHeaderRow1Ref.current.getBoundingClientRect().height);
            }
        };
        measureHeaderRow1();
        window.addEventListener("resize", measureHeaderRow1);
        return () => window.removeEventListener("resize", measureHeaderRow1);
    }, [months]);


    return (
        <>
            {/* ---------- LOADER ---------- */}
            {cloading && (
                <div className="overlay">
                    <Loader />
                    <span style={{ marginLeft: 10 }}>Data loading...</span>
                </div>
            )}

            <ZoomWrapper>
                <div className={isFromApp ? "" : "bg"} style={{ display: "block" }}>


                    {/* ---------- PAGE TITLE ---------- */}


                    {!isFromApp && (
                        <div style={{ textAlign: "center" }}>
                            <span className="font20">COLLECTION RECEIVED</span>
                        </div>
                    )}

                    {!isFromApp && (<div className="orderrow"></div>)}

                    {/* ---------- INFO HEADER ---------- */}
                    <Paper elevation={2} sx={{ p: 2, mb: 3 }}>
                        <Typography
                            variant="body1"
                            sx={{
                                textAlign: "center",
                                color: "#444"
                            }}
                        >
                            COLLECTION RECEIVED AREA WISE & DEALER WISE {prevAndCurrentFY} UPDATED AS ON
                            : {todaysDate || "--"}
                        </Typography>
                    </Paper>

                    {/* ---------- TABLE HEADER ---------- */}
                    <Typography
                        variant="body1"
                        sx={{
                            // textAlign: "center",
                            color: "#ffffff",
                            fontWeight: 500,
                            marginBottom: '9px',
                        }}
                    >
                        {getFYMonthFlowHeader()} COLLECTION RECEIVED MONTH WISE FLOW
                    </Typography>

                    {/* ================= CHART ================= */}
                    <Grid container spacing={2} sx={{ mb: 3 }}>
                        <Grid item xs={12}>
                            <Paper elevation={3} sx={{ p: 1 }}>
                                {/* <Typography
                            variant="subtitle1"
                            align="center"
                            sx={{ mb: 1, fontWeight: 600 }}
                        >
                            MONTH WISE COLLECTION RECEIVED (AMT IN LAC)
                        </Typography> */}

                                <CollectionReceivedLineChart data={summaryChart} />
                            </Paper>
                        </Grid>
                    </Grid>

                    {/* ================= FILTERS ================= */}
                    <Grid container spacing={2} sx={{ mb: 3 }}>
                        {/* ZONE (WITH AMOUNT) */}
                        <Grid item xs={12} md={3}>
                            <div title={zoneTooltip}>
                                <Select
                                    options={addSelectAllOption(zoneOptions)}
                                    value={filters.zone}
                                    onChange={handleZoneChange}

                                    inputValue={zoneSearchText}
                                    onInputChange={(val, { action }) => {
                                        if (action === "input-change") {
                                            setZoneSearchText(val);
                                        }
                                        if (action === "set-value") {
                                            return zoneSearchText;   // preserve typed text
                                        }
                                        return val;
                                    }}

                                    isMulti
                                    isClearable={Boolean(zoneSearchText)}     // ✅ show ❌ only when typing
                                    closeMenuOnSelect={false}
                                    hideSelectedOptions={false}
                                    controlShouldRenderValue={false}

                                    components={{
                                        Option: CheckboxOption,
                                        MultiValue: NoMultiValue,
                                        ClearIndicator: ZoneClearIndicator
                                    }}

                                    placeholder={zonePlaceholder}
                                    onMenuOpen={() => setIsZoneMenuOpen(true)}
                                    onMenuClose={() => setIsZoneMenuOpen(false)}
                                    styles={singleLineSelectStyles}
                                    menuPortalTarget={document.body}
                                />

                            </div>
                        </Grid>

                        {/* MONTH */}
                        <Grid item xs={12} md={2}>
                            <Select
                                options={addSelectAllOption(monthOptions)}
                                value={filters.month}
                                onChange={handleMonthChange}
                                getOptionValue={(opt) => opt.value}
                                getOptionLabel={(opt) => opt.label}
                                isMulti
                                closeMenuOnSelect={false}
                                hideSelectedOptions={false}
                                controlShouldRenderValue={false}
                                components={{
                                    Option: CheckboxOption,
                                    MultiValue: NoMultiValue
                                }}
                                placeholder={monthPlaceholder}
                                onMenuOpen={() => setIsMonthMenuOpen(true)}
                                onMenuClose={() => setIsMonthMenuOpen(false)}
                                menuPortalTarget={document.body}
                                styles={singleLineSelectStyles}
                            />
                        </Grid>

                        {/* DATE RANGE */}
                        <Grid item xs={12} md={2} sx={{ position: "relative" }}>
                            <TextField
                                placeholder="DATE RANGE"
                                value={
                                    range[0].startDate && range[0].endDate
                                        ? `${range[0].startDate.toLocaleDateString("en-GB")} - ${range[0].endDate.toLocaleDateString("en-GB")}`
                                        : ""
                                }
                                onClick={() => setShowCalendar(!showCalendar)}
                                readOnly
                                InputProps={{
                                    readOnly: true,
                                    endAdornment: range[0].startDate && (
                                        <IconButton
                                            size="small"
                                            onClick={(e) => {
                                                e.stopPropagation(); // calendar open hone se roke
                                                clearDateRange();
                                            }}
                                        >
                                            <Clear fontSize="small" sx={{ color: "#666" }} />
                                        </IconButton>
                                    ),
                                }}
                                fullWidth
                                sx={{
                                    backgroundColor: "#fff",
                                    borderRadius: "6px",
                                    cursor: "pointer",
                                }}
                            />
                            {showCalendar && (
                                <ClickAwayListener onClickAway={() => setShowCalendar(false)}>
                                    <Box
                                        sx={{
                                            position: "absolute",
                                            top: "100%",
                                            left: 0,
                                            zIndex: 9999,
                                            boxShadow: 3,
                                            mt: 1,
                                            backgroundColor: "#fff"
                                        }}
                                    >
                                        <DateRange
                                            ranges={range}
                                            onChange={(item) => {
                                                setRange([item.selection]);
                                                handleDateFromChange(
                                                    item.selection.startDate.toLocaleDateString("en-CA")
                                                );
                                                handleDateToChange(
                                                    item.selection.endDate.toLocaleDateString("en-CA")
                                                );
                                                setShowCalendar(false);
                                            }}
                                            maxDate={new Date()}
                                        />
                                    </Box>
                                </ClickAwayListener>
                            )}
                        </Grid>

                        {/* CUSTOMER */}
                        <Grid item xs={12} md={5}>
                            <div title={customerTooltip}>
                                <Select
                                    options={addSelectAllOption(customerNameOptions)}
                                    value={filters.customerName}
                                    onChange={handleCustomerChange}

                                    inputValue={customerSearchText}
                                    onInputChange={(val, { action }) => {
                                        if (action === "input-change") {
                                            setCustomerSearchText(val);
                                        }
                                        if (action === "set-value") {
                                            return customerSearchText;
                                        }
                                        return val;
                                    }}

                                    isMulti
                                    isClearable={Boolean(customerSearchText)}
                                    closeMenuOnSelect={false}
                                    hideSelectedOptions={false}
                                    controlShouldRenderValue={false}

                                    components={{
                                        Option: CheckboxOption,
                                        MultiValue: NoMultiValue,
                                        ClearIndicator: CustomerClearIndicator
                                    }}

                                    placeholder={customerPlaceholder}
                                    onMenuOpen={() => setIsCustomerMenuOpen(true)}
                                    onMenuClose={() => setIsCustomerMenuOpen(false)}
                                    styles={singleLineSelectStyles}
                                    menuPortalTarget={document.body}
                                />

                            </div>
                        </Grid>


                    </Grid>

                       {/* {console.log("grandTotalRaw", grandTotalRaw, "months", months)} */}

                    {/* ================= TABLE + BAR CHART ================= */}
                    <Grid container spacing={2}>
                        <Grid item xs={12} md={8} sx={{ mb: 2 }}>
                            <Grid>
                                <Typography
                                    variant="body1"
                                    sx={{
                                        color: "#ffffff",
                                        fontWeight: 500
                                    }}
                                >
                                    COLLECTION RECEIVED AREA WISE & DEALER WISE{" "}
                                    {getSelectedFYLabel(filters)} (MONTH WISE) (AMOUNT IN LAC)
                                </Typography>
                            </Grid>
                            <Paper >
                                <TableContainer
                                    sx={{
                                        maxHeight: 420,
                                        overflowX: "auto",
                                        overflowY: "auto"
                                    }}
                                >
                                    <Table size="small" stickyHeader>

                                        {/* ================= TABLE HEAD ================= */}
                                        <TableHead>
                                            <TableRow ref={combinedHeaderRow1Ref}>
                                                <TableCell
                                                    rowSpan={2}
                                                    sx={{
                                                        background: "#e0e0e0",
                                                        fontWeight: 600,
                                                        minWidth: 120,
                                                        verticalAlign: "middle",
                                                        position: "sticky",
                                                        top: 0,
                                                        zIndex: 11
                                                    }}
                                                >
                                                    ZONE
                                                </TableCell>

                                                <TableCell
                                                    rowSpan={2}
                                                    sx={{
                                                        background: "#e0e0e0",
                                                        fontWeight: 600,
                                                        minWidth: 220,
                                                        verticalAlign: "middle",
                                                        position: "sticky",
                                                        top: 0,
                                                        zIndex: 11
                                                    }}
                                                >
                                                    CUSTOMER NAME
                                                </TableCell>

                                                {months.map((m) => (
                                                    <TableCell
                                                        key={`${m}-header-group`}
                                                        colSpan={2}
                                                        align="center"
                                                        sx={{
                                                            background: "#e0e0e0",
                                                            fontWeight: 600,
                                                            minWidth: 110,
                                                            whiteSpace: "nowrap",
                                                            borderRight: "1px solid #d0d0d0",
                                                            position: "sticky",
                                                            top: 0,
                                                            zIndex: 11
                                                        }}
                                                    >
                                                        {m}
                                                    </TableCell>
                                                ))}

                                                <TableCell
                                                    rowSpan={2}
                                                    align="right"
                                                    sx={{
                                                        background: "#e0e0e0",
                                                        fontWeight: 700,
                                                        minWidth: 120,
                                                        position: "sticky",
                                                        top: 0,
                                                        right: 0,
                                                        zIndex: 12,
                                                        borderLeft: "2px solid #ccc",
                                                        boxShadow: "-2px 0 4px rgba(0,0,0,0.08)"
                                                    }}
                                                >
                                                    TOTAL
                                                </TableCell>
                                            </TableRow>
                                            <TableRow>
                                                {months.flatMap((m) => [
                                                    <TableCell
                                                        key={`${m}-collection-header`}
                                                        align="center"
                                                        sx={{
                                                            background: "#e0e0e0",
                                                            fontWeight: 600,
                                                            minWidth: 110,
                                                            whiteSpace: "nowrap",
                                                            borderRight: "1px solid #d0d0d0",
                                                            position: "sticky",
                                                            top: combinedHeaderRow1Height,
                                                            zIndex: 10
                                                        }}
                                                    >
                                                        COLLECTION
                                                    </TableCell>,
                                                    <TableCell
                                                        key={`${m}-sales-header`}
                                                        align="center"
                                                        sx={{
                                                            background: "#e0e0e0",
                                                            fontWeight: 600,
                                                            minWidth: 110,
                                                            whiteSpace: "nowrap",
                                                            borderLeft: "1px solid #d0d0d0",
                                                            borderRight: "1px solid #d0d0d0",
                                                            position: "sticky",
                                                            top: combinedHeaderRow1Height,
                                                            zIndex: 10
                                                        }}
                                                    >
                                                        SALES
                                                    </TableCell>
                                                ])}
                                            </TableRow>
                                        </TableHead>
                                        {/* ================= TABLE BODY ================= */}
                                        <TableBody>
                                            {tableRows.length ? (() => {

                                                // ================= GROUP ROWS BY ZONE =================
                                                const grouped = tableRows.reduce((acc, row) => {
                                                    if (!acc[row.zone]) acc[row.zone] = [];
                                                    acc[row.zone].push(row);
                                                    return acc;
                                                }, {});

                                                return Object.entries(grouped).map(([zone, rows]) => (
                                                    <React.Fragment key={zone}>

                                                        {/* ================= CUSTOMER ROWS ================= */}
                                                        {rows.map((row, idx) => (
                                                            <TableRow key={`${zone}-${idx}`} hover>
                                                                {idx === 0 ? (
                                                                    <TableCell
                                                                        rowSpan={rows.length + 1}
                                                                        sx={{
                                                                            fontWeight: 700,
                                                                            verticalAlign: "top",
                                                                            background: "#fafafa",
                                                                            minWidth: 120
                                                                        }}
                                                                    >
                                                                        {zone}
                                                                    </TableCell>
                                                                ) : null}

                                                                <TableCell>{row.customer}</TableCell>

                                                                {months.flatMap((m) => {
                                                                    const collectionValue = row.values?.[m];
                                                                    const salesValue = salesByZoneCustomer?.[zone]?.[row.customer]?.values?.[m];

                                                                    return [
                                                                        <TableCell key={`${zone}-${row.customer}-${m}-collection`} align="right">
                                                                            {collectionValue !== undefined && collectionValue !== null && collectionValue !== "" ? formatToLakh(collectionValue) : "-"}
                                                                        </TableCell>,
                                                                        <TableCell key={`${zone}-${row.customer}-${m}-sales`} align="right" sx={{ borderLeft: "1px solid #eee" }}>
                                                                            {salesValue !== undefined && salesValue !== null && salesValue !== "" ? formatSalesToLakh(salesValue) : "-"}
                                                                        </TableCell>
                                                                    ];
                                                                })}

                                                                <TableCell
                                                                    align="right"
                                                                    sx={{
                                                                        color: "#000 !important",
                                                                        fontWeight: 600,
                                                                        position: "sticky",
                                                                        right: 0,
                                                                        background: "#ffffff",
                                                                        zIndex: 6,
                                                                        borderLeft: "2px solid #eee"
                                                                    }}
                                                                >
                                                                    <div style={{ display: "flex", flexDirection: "column", alignItems: "flex-end", lineHeight: 1.5, color: "#000" }}>
                                                                        <span style={{ color: "#000" }}>
                                                                            {formatToLakh(row.total)}
                                                                        </span>
                                                                        <span style={{ color: "#000" }}>
                                                                            {formatSalesToLakh(salesByZoneCustomer?.[zone]?.[row.customer]?.total ?? 0)}
                                                                        </span>
                                                                    </div>
                                                                </TableCell>
                                                            </TableRow>
                                                        ))}

                                                        {zoneTotals?.[zone] && (
                                                            <TableRow
                                                                sx={{
                                                                    background: "#f1f8ff",
                                                                    borderTop: "2px solid #ddd"
                                                                }}
                                                            >
                                                                <TableCell sx={{ fontWeight: 700 }}>
                                                                    TOTAL
                                                                </TableCell>

                                                                {months.flatMap((m) => {
                                                                    const collectionValue = zoneTotals[zone]?.months?.[m] ?? 0;
                                                                    const salesValue = salesZoneMap?.[zone]?.monthTotals?.[m] ?? 0;

                                                                    return [
                                                                        <TableCell key={`${zone}-total-${m}-collection`} align="right" sx={{ fontWeight: 700 }}>
                                                                            {formatToLakh(collectionValue)}
                                                                        </TableCell>,
                                                                        <TableCell key={`${zone}-total-${m}-sales`} align="right" sx={{ fontWeight: 700, borderLeft: "1px solid #ddd" }}>
                                                                            {formatSalesToLakh(salesValue)}
                                                                        </TableCell>
                                                                    ];
                                                                })}

                                                                <TableCell
                                                                    align="right"
                                                                    sx={{
                                                                        color: "#000 !important",
                                                                        fontWeight: 800,
                                                                        position: "sticky",
                                                                        right: 0,
                                                                        background: "#e3f2fd",
                                                                        zIndex: 7,
                                                                        borderLeft: "2px solid #bbb"
                                                                    }}
                                                                >
                                                                    <div
                                                                        style={{
                                                                            display: "flex",
                                                                            flexDirection: "column",
                                                                            alignItems: "flex-end",
                                                                            lineHeight: 1.5,
                                                                            color: "#000"
                                                                        }}
                                                                    >
                                                                        <span style={{ color: "#000" }}>
                                                                            {formatToLakh(zoneTotals[zone]?.total ?? 0)}
                                                                        </span>
                                                                        <span style={{ color: "#000" }}>
                                                                            {formatSalesToLakh(salesZoneMap?.[zone]?.total ?? 0)}
                                                                        </span>
                                                                    </div>
                                                                </TableCell>
                                                            </TableRow>
                                                        )}

                                                    </React.Fragment>
                                                ));
                                            })() : (
                                                <TableRow>
                                                    <TableCell colSpan={months.length * 2 + 3} align="center">
                                                        NO DATA FOUND
                                                    </TableCell>
                                                </TableRow>
                                            )}

                                            {tableRows.length > 0 && (
                                                <TableRow
                                                    sx={{
                                                        background: "#f5f5f5",
                                                        position: "sticky",
                                                        bottom: 0,
                                                        zIndex: 3
                                                    }}
                                                >
                                                    <TableCell colSpan={2} sx={{ fontWeight: 700 }}>
                                                        GRAND TOTAL
                                                    </TableCell>

                                                    {months.flatMap((m) => [
                                                        <TableCell key={`grand-${m}-collection`} align="right" sx={{ fontWeight: 700 }}>
                                                            {grandTotal?.[m] !== undefined ? formatToLakh(grandTotal[m]) : "-"}
                                                        </TableCell>,
                                                        <TableCell key={`grand-${m}-sales`} align="right" sx={{ fontWeight: 700, borderLeft: "1px solid #ddd" }}>
                                                            {salesTableData.grandMonths?.[m] !== undefined ? formatSalesToLakh(salesTableData.grandMonths[m]) : "-"}
                                                        </TableCell>
                                                    ])}

                                                    <TableCell
                                                        align="right"
                                                        sx={{
                                                            color: "#000 !important",
                                                            fontWeight: 800,
                                                            background: "#e0e0e0",
                                                            position: "sticky",
                                                            bottom: 0,
                                                            right: 0,
                                                            zIndex: 9,
                                                            borderLeft: "2px solid #999"
                                                        }}
                                                    >
                                                        <div
                                                            style={{
                                                                display: "flex",
                                                                flexDirection: "column",
                                                                alignItems: "flex-end",
                                                                lineHeight: 1.5,
                                                                color: "#000"
                                                            }}
                                                        >
                                                            <span style={{ color: "#000" }}>
                                                                {formatToLakh(grandTotal?.total ?? 0)}
                                                            </span>
                                                            <span style={{ color: "#000" }}>
                                                                {formatSalesToLakh(salesTableData.grandTotalValue ?? 0)}
                                                            </span>
                                                        </div>
                                                    </TableCell>
                                                </TableRow>
                                            )}
                                        </TableBody>
                                    </Table>

                                </TableContainer>
                                {/* <TablePagination
                            component="div"
                            rowsPerPageOptions={[100]}
                            count={totalRecords}
                            rowsPerPage={100}
                            page={page - 1}
                            onPageChange={handleChangePage}
                        /> */}
                            </Paper>
                        </Grid>
                        <Grid item xs={12} md={4}>
                            <Grid >
                                <Typography
                                    variant="body1"
                                    sx={{
                                        color: "#ffffff",
                                        fontWeight: 500
                                    }}
                                >
                                    TOP 10 CUSTOMER LIST CUSTOMER WISE
                                </Typography>
                            </Grid>
                            <Paper elevation={3} sx={{ p: 1, height: "100%" }}>
                                <CollectionReceivedBarChart data={barChartData} fyLabel={fyLabel} />
                            </Paper>
                        </Grid>
                    </Grid>

                    {/* <Grid container spacing={2} sx={{ mt: 1 }}>
                        <Grid item xs={12}>
                            <Typography
                                variant="body1"
                                sx={{
                                    color: "#ffffff",
                                    fontWeight: 500,
                                    marginBottom: "9px"
                                }}
                            >
                                SALES AREA WISE & DEALER WISE {getSelectedFYLabel(filters)} (MONTH WISE) (AMOUNT IN LAC)
                            </Typography>
                            <Paper>
                                <TableContainer sx={{ maxHeight: 420, overflowX: "auto" }}>
                                    <Table size="small" stickyHeader>
                                        <TableHead>
                                            <TableRow>
                                                <TableCell rowSpan={2} sx={{ background: "#e0e0e0", fontWeight: 600, minWidth: 120, verticalAlign: "middle" }}>
                                                    ZONE
                                                </TableCell>
                                                <TableCell rowSpan={2} sx={{ background: "#e0e0e0", fontWeight: 600, minWidth: 220, verticalAlign: "middle" }}>
                                                    CUSTOMER NAME
                                                </TableCell>
                                                {months.map((m) => (
                                                    <TableCell key={`sales-${m}`} align="center" sx={{ background: "#e0e0e0", fontWeight: 600, minWidth: 110, whiteSpace: "nowrap", borderRight: "1px solid #d0d0d0" }}>
                                                        {m}
                                                    </TableCell>
                                                ))}
                                                <TableCell rowSpan={2} align="right" sx={{ background: "#e0e0e0", fontWeight: 700, minWidth: 120, position: "sticky", right: 0, zIndex: 10, borderLeft: "2px solid #ccc", boxShadow: "-2px 0 4px rgba(0,0,0,0.08)" }}>
                                                    TOTAL
                                                </TableCell>
                                            </TableRow>
                                        </TableHead>
                                        <TableBody>
                                            {salesTableData.zones.length ? (
                                                <>
                                                    {salesTableData.zones.map((zoneEntry) => (
                                                        <React.Fragment key={`sales-zone-${zoneEntry.zone}`}>
                                                            {zoneEntry.rows.map((row, idx) => (
                                                                <TableRow key={`sales-row-${zoneEntry.zone}-${row.customer || idx}`} hover>
                                                                    {idx === 0 ? (
                                                                        <TableCell rowSpan={zoneEntry.rows.length + 1} sx={{ fontWeight: 700, verticalAlign: "top", background: "#fafafa", minWidth: 120 }}>
                                                                            {zoneEntry.zone}
                                                                        </TableCell>
                                                                    ) : null}
                                                                    <TableCell>{row.customer}</TableCell>
                                                                    {months.map((month) => (
                                                                        <TableCell key={`sales-cell-${zoneEntry.zone}-${row.customer}-${month}`} align="right">
                                                                            {row.values?.[month] ? formatToLakh(row.values[month]) : "-"}
                                                                        </TableCell>
                                                                    ))}
                                                                    <TableCell align="right" sx={{ fontWeight: 600, position: "sticky", right: 0, background: "#ffffff", zIndex: 6, borderLeft: "2px solid #eee" }}>
                                                                        {formatToLakh(row.total)}
                                                                    </TableCell>
                                                                </TableRow>
                                                            ))}
                                                            <TableRow sx={{ background: "#f1f8ff", borderTop: "2px solid #ddd" }}>
                                                                <TableCell sx={{ fontWeight: 700 }}>TOTAL</TableCell>
                                                                {months.map((month) => (
                                                                    <TableCell key={`sales-zone-total-${zoneEntry.zone}-${month}`} align="right" sx={{ fontWeight: 700 }}>
                                                                        {zoneEntry.monthTotals?.[month] !== undefined ? formatToLakh(zoneEntry.monthTotals[month]) : "-"}
                                                                    </TableCell>
                                                                ))}
                                                                <TableCell align="right" sx={{ fontWeight: 800, position: "sticky", right: 0, background: "#e3f2fd", zIndex: 7, borderLeft: "2px solid #bbb" }}>
                                                                    {formatToLakh(zoneEntry.total ?? 0)}
                                                                </TableCell>
                                                            </TableRow>
                                                        </React.Fragment>
                                                    ))}

                                                    <TableRow sx={{ background: "#f5f5f5", position: "sticky", bottom: 0, zIndex: 3 }}>
                                                        <TableCell colSpan={2} sx={{ fontWeight: 700 }}>GRAND TOTAL</TableCell>
                                                        {months.map((month) => (
                                                            <TableCell key={`sales-grand-${month}`} align="right" sx={{ fontWeight: 700 }}>
                                                                {salesTableData.grandMonths?.[month] !== undefined ? formatToLakh(salesTableData.grandMonths[month]) : "-"}
                                                            </TableCell>
                                                        ))}
                                                        <TableCell align="right" sx={{ fontWeight: 800, background: "#e0e0e0", position: "sticky", bottom: 0, right: 0, zIndex: 9, borderLeft: "2px solid #999" }}>
                                                            {formatToLakh(salesTableData.grandTotalValue ?? 0)}
                                                        </TableCell>
                                                    </TableRow>
                                                </>
                                            ) : (
                                                <TableRow>
                                                    <TableCell colSpan={months.length + 3} align="center">NO DATA FOUND</TableCell>
                                                </TableRow>
                                            )}
                                        </TableBody>
                                    </Table>
                                </TableContainer>
                            </Paper>
                        </Grid>
                    </Grid> */}

                </div>
            </ZoomWrapper>
        </>
    );
};

export default CollectionReceived;